// DS2.7
import React from 'react';
import classnames from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import PlusIcon from '../Icons/AddPlus';
import { IconSize } from '../Icons/IconWrap';
import s from './AddItem.scss';
const AddItem = ({ className, onClick, title, titleClassName, disabled, subtitle, biData, innerRef, icon: Icon = PlusIcon, iconSize = IconSize.TINY, withCardWrapper = true, error })=>{
    return /*#__PURE__*/ React.createElement(BiButton, {
        className: classnames(withCardWrapper ? 'ds-card' : s['borderless'], s['root'], className, disabled && s['disabled'], error && s['error']),
        onClick: onClick,
        biData: biData,
        innerRef: innerRef
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: s['plus'],
        size: iconSize
    }), title && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['title'], titleClassName)
    }, title), subtitle && /*#__PURE__*/ React.createElement("div", {
        className: s['subtitle']
    }, subtitle));
};
AddItem.displayName = 'AddItem';
export default AddItem;
